/* global Modernizr, _ */
(function( $ ) {
    'use strict';

    $(function() {
        $( document ).on( 'click', '[data-toggle]', function() {
            var $this = $( this ),
                $target = $( $this.data( 'toggle' ) );

            $this.toggleClass( 'open' );
            $target.slideToggle();
        });

        $('.menu').slicknav({
            prependTo: '#site-nav'
        });

        $( '.slick' ).slick({
            infinite: true,
            lazyLoad: 'ondemand',
            speed: 300
        });
    });
})( jQuery );
